import { type GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetSubscriptionsQuery } from '../../data/queries/get-subscriptions.query'
import { type Subscription } from '../models/subscription'

export class GetSubscriptionsInteractor {
  constructor(
    private readonly getSubscriptions: GetInteractor<Subscription[]>
  ) {
  }

  public async execute(customerId: string, transactionId: string): Promise<Subscription[]> {
    return await this.getSubscriptions.execute(new GetSubscriptionsQuery(customerId, transactionId))
  }
}
